import { z } from 'zod';

export const WeekdayNameSchema = z.enum(['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']);
export type WeekdayName = z.infer<typeof WeekdayNameSchema>;
